import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LinkButton } from '../../../CommonComponents/Button';
import { StyledCollapsible, Title } from './CollapsibleStyles';

const Collapsible = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <StyledCollapsible>
      <LinkButton
        onClick={() => setIsOpen(!isOpen)}
        prependIcon={isOpen ? 'fas fa-caret-down' : 'fas fa-caret-right'}
        style={{ color: '#9c9c9c' }}
      >
        <Title>{title}</Title>
      </LinkButton>
      {isOpen && children}
    </StyledCollapsible>
  );
};

Collapsible.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Collapsible;
